/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useEffect, useState } from 'react';
import { SvgHandler } from '../../../../svg-handler/svg-handler';
import GreenTickIcon from '../../../../../../assets/icons/green-tick.svg';
import './success-message.module.css';

export const SuccessMessage = ({ message, mode, isUserLoginPage = false, defaultRedirectUrl = '', sessionLimit, pageType }) => {
  const loginPageRedirectUrl = !isUserLoginPage ? global?.localStorage?.getItem('loginRedirectUrl') || '/' : null;
  const redirectUrl = defaultRedirectUrl ? defaultRedirectUrl : loginPageRedirectUrl;
  const { enableSessionLimit = false, maxSessionsPerUser } = sessionLimit || {};
  const [showMessage, setShowMessage] = useState(enableSessionLimit ? false : true)

  useEffect(() => {
    async function getSessionCount() {
      if (!enableSessionLimit) return;
      const { count } = await (await fetch('/api/auth/v1/sessions')).json();
      if (count > parseInt(maxSessionsPerUser)) setShowMessage(false);
      else setShowMessage(true)
    }
    getSessionCount();
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (!isUserLoginPage) {
        global?.localStorage?.removeItem(defaultRedirectUrl ? "sessionExceededRedirectUrl" : "loginRedirectUrl");
        window.location.href = redirectUrl;
      }
    }, 3000);
  }, [message]);

  if (pageType === 'session-exceeded') {
    return (
      showMessage && (<div styleName={`content-wrapper-session-page ${mode}`}>
        <SvgHandler xlinkHref={GreenTickIcon} width='24' height='24' viewBox='0 0 24 24' />
        <span styleName='message'>{message}</span>
      </div>)
    );
  }

  return (
    showMessage && (<div styleName={`content-wrapper ${mode}`}>
      <SvgHandler xlinkHref={GreenTickIcon} width='24' height='24' viewBox='0 0 24 24' />
      <span styleName='message'>{message}</span>
    </div>)
  );
};
